// Legacy SmartAdmin-era plugins expect a global moment. This used to live in src/polyfills.ts. It moved here, imported
// first by main.ts, because @angular/build treats any .ts file in the `polyfills` array as a sign the app may load
// zone.js. It then downlevels async/await and rejects top-level await, which breaks the zoneless unit-test setup
// (AB#23266). `@angular/localize/init`, the other entry that file had, is now listed in angular.json by package name.
import moment from 'moment';
(window as any).moment = moment;
